import axios from "axios";
import Vue from "vue";
// import store from "../store";
// import qs from 'qs'
import router from "../router";

let config = {
  timeout: 10 * 1000, // Timeout
  withCredentials: false // Check cross-site Access-Control
};

if (process.env.NODE_ENV == "development") {
  // dev开发环境
  config.baseURL = "";
} else if (process.env.NODE_ENV == "production") {
  // build生产环境
  config.baseURL = "";
  // config.baseURL = "https://api.ascod.cn";
  // config.baseURL = window.location.origin;
}

const _axios = axios.create(config);

// _axios.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded"
_axios.defaults.headers.post["Content-Type"] =
  "application/json; charset=utf-8";
// _axios.defaults.headers.common['token'] = localStorage.getItem('token')

_axios.interceptors.request.use(
  function (config) {
    const requestUrl = config.url || "";

    // 按 URL 直接设置超时（优先级高于白名单，避免被覆盖）
    if (requestUrl.indexOf("/iotUser-api/v1/ysVideo/capture") > -1) {
      config.timeout = 60 * 1000;
    }

    const white = [
      "/iotUser-api/v1/gateway/getMeteorologicalData",
      "/iotUser-api/v1/mail/sendForCsv",
      "/iotUser-api/v1/notifyCenter/list",
      "/iotUser-api/v1/irrigationProgram/add",
      "/iotUser-api/v1/cameraImg/ndviDeal",
      "/iotUser-api/v1/video/devicePlay",
      "/iotUser-api/v1/gatewayValveGroup/getGroup",
      "/iotUser-api/v1/program/readValveStatus",
      "/iotUser-api/v1/gatewayValveGroup/getGroupStatus",
      "/iotUser-api/v1/gatewayValveGroup/getAllValveStatus",
      "/iotUser-api/v1/baidu/citrusClassification", // 生长识别
      "/iotUser-api/v1/imageRecognition/citrusClassification", // 果实识别
      "/iotUser-api/v1/rtu/unBindGateway",
      "/iotUser-api/v1/program/readSetting",
    ];

    const second30 = [
      "/iotUser-api/v1/baidu/citrusClassification", // 生长识别
      "/iotUser-api/v1/imageRecognition/citrusClassification", // 果实识别
      "/iotUser-api/v1/gatewayValveGroup2/getGroup", // 轮灌组
      "/iotUser-api/v1/gatewayValveGroup2/getProgramList", //读取程序列表
      "/iotUser-api/v1/rtu/unBindGateway",
    ];

    const target = white.find(o => {
      if (config.url.indexOf(o) > -1) {
        return o;
      }
    });

    if (
      requestUrl.indexOf("/iotUser-api/v1/ysVideo/capture") === -1 &&
      target &&
      second30.findIndex(o => target.indexOf(o)) > -1
    ) {
      config.timeout = 300 * 1000;
    } else if (
      requestUrl.indexOf("/iotUser-api/v1/ysVideo/capture") === -1 &&
      target
    ) {
      config.timeout = 30 * 1000;
    }
    // Do something before request is sent
    if (localStorage.getItem("token")) {
      config.headers.common.token = localStorage.getItem("token");
    }
    if (config.method == "post") {
      // 可做字符串化传参数据
      // config.data = qs.stringify(config.data)
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

let self = Vue.prototype;

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    const ua = navigator.userAgent.toLowerCase();
    const isWechat = ua.match(/MicroMessenger/i)
      ? ua.match(/MicroMessenger/i)[0] === "micromessenger"
      : false;

    // 如果http状态码不是200 则返回一个错误提示
    if (response?.status != 200) {
      console.log("状态码 不对:");
      Vue.prototype?.$toast?.clear()
      Vue.prototype?.$toast?.(`请求失败，请重试 状态码${response?.status}`)
      return
    }

    if (response.data.errcode === 0 || response.data.code === 200) {
      // 接口状态正常
      return Promise.resolve(response);
    } else if (response.data.errcode === 650 || response.data.errcode === 651) {
      self.$toast.clear();
      self.$toast("登录已过期，请重新登录");
      localStorage.removeItem("token");
      if (response.data.errcode === 651) {
        localStorage.setItem("snsapi", "snsapi_userinfo");
      }

      // //退出登录开始
      // var user = new Object();
      // user['user_id'] = 0;
      // user['user_name'] = "点击登录";
      // user['user_face'] = `${require('@/assets/images/face.png')}`;
      // user['user_tel'] = "";
      // localStorage.setItem('user', JSON.stringify(user));
      // localStorage.setItem('user_id', user['user_id']);
      // localStorage.setItem('user_name', user['user_name']);
      // localStorage.setItem('user_face', user['user_face']);
      // localStorage.setItem('user_tel', user['user_tel']);
      // localStorage.setItem('retrunpath', "/")
      if (isWechat) {
        router.replace({
          path: "/live",
          query: {
            redirect: router.currentRoute.fullPath
          } // 登录成功后跳入浏览的当前页面
        });
        return;
      }

      const isWebview = sessionStorage.getItem("isWebview");
      if (isWebview) {
        // 给外部对接的页面出现登录过期了 则跳转去一个 授权过期的页面
        return router.replace({
          path: "/tokenExpire",
          query: {
            redirect: router.currentRoute.fullPath
          } // 登录成功后跳入浏览的当前页面
        });
      }
      // 退出登录开始结束end
      router.replace({
        path: "/login",
        query: {
          redirect: router.currentRoute.fullPath
        } // 登录成功后跳入浏览的当前页面
      });
    } else {
      return Promise.resolve(response);
    }
  },

  async function (err) {
    if (err.message.includes("timeout")) {
      // 判断请求异常信息中是否含有超时timeout字符串
      const lan = localStorage.getItem("language");
      const json = await import(`@/utils/lan/${lan}.json`);
      self.$toast(`${json.common.timeout}`);
    }
    return Promise.reject(err);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    _axios
      .get(url, {
        params: params
      })
      .then(response => {
        // console.log("responseresponse222：", response);

        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data = {}, method = "post", config = {}) {
  return new Promise((resolve, reject) => {
    _axios[method](url, data, { ...config })
      .then(response => {
        if (response) {
          return resolve(response.data);
        } else {
          return resolve(response);
        }
      })
      .catch(err => {
        console.error(err);
        return reject(err);
      });
  });
}

/**
 * 封装文件上传请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function uploadRequest (url, params) {
  console.log("params:", params);
  const formData = new FormData();
  formData.append("file", params.file);

  return new Promise((resolve, reject) => {
    _axios
      .post(url, formData, {
        headers: { contentType: "multipart/form-data" }
      })
      .then(response => {
        if (response) {
          resolve(response.data);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        console.error("上传文件失败:", err);
        reject(err);
      });
  });
}

export default _axios;
